// core version + navigation, pagination modules:
import Swiper, {Autoplay, Navigation} from 'swiper'

export default class Sliders {
  constructor(slider, index) {
    this.slider = slider
    this.index = index
    this.slides = Array.from(this.slider.querySelectorAll('.swiper-slide'))
    this.arrows = this.slider.querySelector('.swiper-arrows')

    this.options = this.setOptions()
    this.initSlider()
  }

  setOptions() {
    let options = {}

    if (this.slider.classList.contains('swiper--about')) {
      options = {
        modules: [Autoplay, Navigation],
        autoplay: {
          delay: 5000,
        },
        centeredSlides: false,
        keyboardControl: true,
        loop: false,
        navigation: {
          nextEl: '.swiper-button-next--about',
          prevEl: '.swiper-button-prev--about',
        },
        slidesPerView: 1,
        watchOverflow: true,
      }
    }

    return options
  }

  initSlider() {
    console.log('  -> Sliders init')
    let swiperInstance = new Swiper(this.slider, this.options)
    swiperInstance.init()
    this.swiperInstance = swiperInstance
  }

  destroy() {
    console.log('  -> Sliders destroy', this.node)
    this.swiperInstance.destroy()
  }

  static destroyAll() {
    console.log('  -> Sliders destroy all')
    Sliders.items.forEach((slider) => {
      slider.destroy()
    })
  }

  static init() {
    console.log('== Sliders components ==')
    Sliders.items = Array.from(document.querySelectorAll('.swiper')).map(
      (slider, index) => new Sliders(slider, index)
    )
  }
}
